module.exports = "<li :class=\"[active ? 'active' : '']\"> <dropdown type=none icon=arrow_drop_down :icon-position=iconPosition :label=label :items=items :hover=false> <slot></slot> </dropdown> </li>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../~/material-ui-vue/components/navbar/nav-dropdown-item.vue
 ** module id = 81
 ** module chunks = 0
 **/